import type { EntityType } from "@/services/sharing";

/**
 * What the email compose step calls the item ("Emailed the report to 2
 * people."). For a workspace the page path is the only signal of which kind
 * it is.
 */
export const emailNounFor = (entityType: EntityType): string => {
  const pathname = window.location.pathname;
  switch (entityType) {
    case "interaction":
      return "note";
    case "conversation":
      return "chat";
    case "view":
      return "view";
    case "view-group":
      return "group";
    case "agent":
      return "agent";
    case "skill":
      return "skill";
    case "artifact":
      return "document";
    case "artifact-folder":
      return "folder";
    case "workspace":
      // Reports, matrices and legacy chats share one entity type; the page
      // path is the only signal of which one is open (ShareModal's
      // handleCopyLink makes the same sniff).
      if (pathname.includes("/matrix")) return "matrix";
      if (pathname.includes("/report")) return "report";
      return "chat";
  }
};
